// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import Jubail from '@/assets/img/Jubail.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';
// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const JUBAIL_PROFILE_CONFIG = {

//   jubail_on_street_profile: {
//     profileKey:   'jubail_on_street_profile',
//     violationKey: 'jubail_on_street_violations',
//     assetsKey:    'jubail_on_street_assets',

//     profileFallback: {
//       table_key: 'jubail_on_street_profile',
//       title: 'Jubail On Street - Profile',
//       data: {
//         total_bays:      { label: 'Total On-Street Parking Bays', value: '3,320' },
//         contract_term:   { value: '7 years ;' },
//         contract_period: { start_date: '07.09.2019', end_date: '22.06.2026' },
//         rate_per_hour:   { value: '0-2 Hours SAR 2.00 plus vat, 3rd Hour onwards SAR 1.00 plus vat' },
//         working_hours:   { value: 'Morning 08:00 to 12:00 noon, Evening 16:00 - 22:00' },
//       },
//     },

//     violationFallback: {
//       table_key: 'jubail_on_street_violations',
//       title: 'Jubail On Street Violation Summary (Excluding Vat)',
//       data: {
//         rows: [
//           { city_code: 'JUB', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',                     ticket_charges: '200',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',     ticket_charges: '100',         tow_charges: '-',       clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                     ticket_charges: '100',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                             ticket_charges: '100',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                          ticket_charges: '300',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                                ticket_charges: '300',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400', tow_charges: '250',   clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                    ticket_charges: '900',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                              ticket_charges: '500',         tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                           ticket_charges: '0',           tow_charges: '250/1250', clamp_charges: '0' },
//           { city_code: 'JUB', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                       ticket_charges: '20/50 per day', tow_charges: '0',   clamp_charges: '0' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'jubail_on_street_assets',
//       title: 'Jubail On-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
//           apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '3', ipBarrier: '2', anprCamera: '2', arh: '2',
//           slidingGate: '-',
//           pnds: '224', tpalTx: '144', tpalV2: '80',
//           enfDevice: '38', oukitel: '32', doogee: '6',
//           printer: '22', pr3: '10', sewoo: '8', bixolon: '4',
//           towTruck: '7', clampVehicle: '2', supportVehicle: '1',
//         }),
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const JubailProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = JUBAIL_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef       = useRef(null);
//   const [isSaving, setIsSaving]             = useState(false);
//   const [profileTable, setProfileTable]     = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable]       = useState(cfg.assetsFallback);
//   const [violationTable, setViolationTable] = useState(cfg.violationFallback);
//   const { enqueue } = useApiQueue();

//     // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef   = useRef(null);
//   const assetsRef    = useRef(null);
//   const violationRef = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => { profileRef.current   = profileTable;   }, [profileTable]);
//   useEffect(() => { assetsRef.current    = assetsTable;    }, [assetsTable]);
//   useEffect(() => { violationRef.current = violationTable; }, [violationTable]);
//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       setViolationTable(find(cfg.violationKey, cfg.violationFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//     // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: profileRef.current?.table_key, 
//           title: profileRef.current?.title, 
//           data: profileRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       if (violationRef.current) {
//         tables.push({ 
//           table_key: violationRef.current.table_key, 
//           title: violationRef.current.title, 
//           data: violationRef.current.data 
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1, 
//         tables,
//       });

//       if (!res?.success) throw new Error(res?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleViolationCell = (rIdx, key, value) => {
//     setViolationTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const pd         = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-8 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-4">
//         <div className="ml-2">
//           {/* Replace with: import JubailLogo from '@/assets/img/JubailLogo.png' */}
//           <img src={Jubail} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} /> 
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

      

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-6">

//         {/* ══ LEFT ══ */}
//         <div className="flex-1 pr-4">

//  <div className="flex flex-col">
// {/* ── Activities ── */}
//       <div className="mb-5">
//         <p className="text-[16px] font-bold mb-10">Activities:</p>
//         <div className="flex gap-10">
//           {['On Street', 'Enforcement'].map(label => (
//             <div key={label} className="flex flex-col items-center gap-2">
//                {/* <div className='text-[20px] font-semibold'>Activities</div>   */}
//                   <div className="w-40 h-28  rounded-lg flex items-center justify-center text-gray-400 text-[11px]">
//                 {label === 'On Street' ? <img src={OnStreet} alt="Bab Al Ree Logo" style={{ height: '200px', objectFit: 'contain' }} />:  <img src={Enforcement} alt="Bab Al Ree Logo" style={{ height: '200px', objectFit: 'contain' }} />}
//               </div>
//               {/* <span className="text-[13px] font-semibold">{label}</span> */}
//             </div>
//           ))}
//         </div>
//       </div>
//  {/* Profile info */}
//           <div className="flex flex-col gap-1.5 mb-5 mt-3">

//             {/* Total Bays */}
//             <div className="flex items-center gap-2">
//               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//               <span className="text-[12px]">
//                 {pd.total_bays?.label}{' '}
//                 <strong>
//                   <input type="text" value={pd.total_bays?.value || ''}
//                     onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" />
//                 </strong>
//               </span>
//             </div>

//             {/* Contract Term */}
//             <div className="flex items-center gap-2 ml-5">
//               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//               <span className="text-[12px] flex items-center flex-wrap gap-1">
//                 Contract term{' '}
//                 <strong><input type="text" value={pd.contract_term?.value || ''}
//                   onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//                  start date{' '}
//                 <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                   onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17" /></strong>
//                 {' to '}
//                 <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                   onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px] " /></strong>
//               </span>
//             </div>

//             {/* Rate Per Hour */}
//             <div className="flex items-center gap-2 ml-5">
//               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//               <span className="text-[12px]">
//                 Rate Per Hour –{' '}
//                 <strong>
//                   <input type="text" value={pd.rate_per_hour?.value || ''}
//                     onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-96" />
//                 </strong>
//               </span>
//             </div>

//             {/* Working Hours */}
//             <div className="flex items-center gap-2 ml-5">
//               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//               <span className="text-[12px]">
//                 Working Hours –{' '}
//                 <strong>
//                   <input type="text" value={pd.working_hours?.value || ''}
//                     onChange={e => patchProfile('working_hours', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-80" />
//                 </strong>
//               </span>
//             </div>

//             {/* Assets Deployed */}
//             <div className="flex items-center gap-2 ml-5">
//               <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//               <span className="text-[12px]">Assets Deployed</span>
//             </div>
//           </div>
//  </div>
         

//           {/* ── Violation Summary Table ── */}
//           <div className="">
//             <table className="!border-collapse text-[8px]">
//               <thead>
//                 <tr>
//                   <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[10px]">
//                     {violationTable.title}
//                   </th>
//                 </tr>
//                 <tr className="">
//                   {[
//                     { label: 'City Code',        w: '55px'  },
//                     { label: 'Violation Code',   w: '60px'  },
//                     { label: 'Violation_Name_En', w: '210px' },
//                     { label: 'Ticket Charges',   w: '70px'  },
//                     { label: 'Tow Charges',      w: '65px'  },
//                     { label: 'Clamp Charges',    w: '65px'  },
//                   ].map(({ label, w }) => (
//                     <th key={label} className="!border !border-black px-2 py-1 font-bold text-center" style={{ minWidth: w }}>
//                       {label}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {violationTable.data.rows.map((row, rIdx) => (
//                   <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
//                     {[
//                       { key: 'city_code',       w: '55px'  },
//                       { key: 'violation_code',  w: '60px'  },
//                       { key: 'violation_name',  isLong:true },
//                       { key: 'ticket_charges',  w: '70px'  },
//                       { key: 'tow_charges',     w: '65px'  },
//                       { key: 'clamp_charges',   w: '65px'  },
//                     ].map(({ key, w ,isLong}) => (
//                       // <td key={key} className="!border !border-black px-1.5 py-0.5">
//                       //   <input
//                       //     type="text"
//                       //     value={row[key] || ''}
//                       //     onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//                       //     className="!border-0 bg-transparent outline-none text-[8px]"
//                       //     style={{ width: w }}
//                       //   />
//                       // </td>
// <td key={key} className="!border !border-black px-1.5 py-0.5">
//   {isLong ? (
//     <textarea
//       id={`violation-cell-${rIdx}-${key}`}
//       value={row[key] || ''}
//       onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//       rows={1}
//       className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//       style={{
//         width: w,          // same as input width
//         minWidth: '260px', // same as your first snippet
//         minHeight: '22px',
//         lineHeight: '1.2',
//         padding: '3px 4px',
//       }}
//       onInput={e => {
//         e.target.style.height = 'auto';
//         e.target.style.height = e.target.scrollHeight + 'px';
//       }}
//     />
//   ) : (
//     <input
//       type="text"
//       value={row[key] || ''}
//       onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//       className="!border-0 bg-transparent outline-none text-[8px] text-center"
//       style={{ width: w }}
//     />
//   )}
// </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ══ RIGHT — Assets Panel ══ */}
//         <AssetsPanel
//           assetsTable={assetsTable}
//           flatAssets={flatAssets}
//           onSubCount={handleAssetSubCount}
//           onTotalCount={handleAssetTotalCount}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default JubailProfile;








import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import Jubail from '@/assets/img/Jubail.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const JUBAIL_PROFILE_CONFIG = {

  jubail_on_street_profile: {
    profileKey:   'jubail_on_street_profile',
    violationKey: 'jubail_on_street_violations',
    assetsKey:    'jubail_on_street_assets',

    profileFallback: {
      table_key: 'jubail_on_street_profile',
      title: 'Jubail On Street - Profile',
      data: {
        total_bays:      { label: 'Total On-Street Parking Bays', value: '3,320' },
        contract_term:   { value: '7 years ;' },
        contract_period: { start_date: '07.09.2019', end_date: '22.06.2026' },
        rate_per_hour:   { value: '0-2 Hours SAR 2.00 plus vat, 3rd Hour onwards SAR 1.00 plus vat' },
        working_hours:   { value: 'Morning 08:00 to 12:00 noon, Evening 16:00 - 22:00' },
      },
    },

    violationFallback: {
      table_key: 'jubail_on_street_violations',
      title: 'Jubail On Street Violation Summary (Excluding Vat)',
      data: {
        rows: [
          { city_code: 'JUB', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',                     ticket_charges: '200',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',     ticket_charges: '100',         tow_charges: '-',       clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                     ticket_charges: '100',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                             ticket_charges: '100',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                          ticket_charges: '300',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                                ticket_charges: '300',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400', tow_charges: '250',   clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                    ticket_charges: '900',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                              ticket_charges: '500',         tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                           ticket_charges: '0',           tow_charges: '250/1250', clamp_charges: '0' },
          { city_code: 'JUB', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                       ticket_charges: '20/50 per day', tow_charges: '0',   clamp_charges: '0' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'jubail_on_street_assets',
      title: 'Jubail On-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '3', ipBarrier: '2', anprCamera: '2', arh: '2',
          slidingGate: '-',
          pnds: '224', tpalTx: '144', tpalV2: '80',
          enfDevice: '38', oukitel: '32', doogee: '6',
          printer: '22', pr3: '10', sewoo: '8', bixolon: '4',
          towTruck: '7', clampVehicle: '2', supportVehicle: '1',
        }),
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const JubailProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = JUBAIL_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef       = useRef(null);
  const [isSaving, setIsSaving]             = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable]     = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable]       = useState(cfg.assetsFallback);
  const [violationTable, setViolationTable] = useState(cfg.violationFallback);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.total_bays?.value ?? '0';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef   = useRef(null);
  const assetsRef    = useRef(null);
  const violationRef = useRef(null);

  // Sync refs with latest state
  useEffect(() => { profileRef.current   = profileTable;   }, [profileTable]);
  useEffect(() => { assetsRef.current    = assetsTable;    }, [assetsTable]);
  useEffect(() => { violationRef.current = violationTable; }, [violationTable]);
  
  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params
      const secondApiParams = {
        contract: "0030013",
        year: year,
        month: month,
        device_onstreet: "JUB",
        type: "on_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        setViolationTable(find(cfg.violationKey, cfg.violationFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: profileRef.current?.table_key, 
          title: profileRef.current?.title, 
          data: profileRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      if (violationRef.current) {
        tables.push({ 
          table_key: violationRef.current.table_key, 
          title: violationRef.current.title, 
          data: violationRef.current.data 
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1, 
        tables,
      });

      if (!res?.success) throw new Error(res?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleViolationCell = (rIdx, key, value) => {
    setViolationTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const pd         = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-4">
        <div className="ml-2">
          <img src={Jubail} alt="Jubail Logo" style={{ height: '50px', objectFit: 'contain' }} /> 
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-6">

        {/* ══ LEFT ══ */}
        <div className="flex-1 pr-4">

          <div className="flex flex-col">
            {/* ── Activities ── */}
            <div className="mb-5">
              <p className="text-[16px] font-bold mb-10">Activities:</p>
              <div className="flex gap-10">
                {['On Street', 'Enforcement'].map(label => (
                  <div key={label} className="flex flex-col items-center gap-2">
                    <div className="w-40 h-28 rounded-lg flex items-center justify-center text-gray-400 text-[11px]">
                      {label === 'On Street' ? 
                        <img src={OnStreet} alt="On Street" style={{ height: '200px', objectFit: 'contain' }} /> : 
                        <img src={Enforcement} alt="Enforcement" style={{ height: '200px', objectFit: 'contain' }} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Profile info */}
            <div className="flex flex-col gap-1.5 mb-5 mt-3">

              {/* 🔥 READ-ONLY Total Bays */}
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
                    />
                  </strong>
                </span>
              </div>

              {/* Contract Term - Editable */}
              <div className="flex items-center gap-2 ml-5">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Contract term{' '}
                  <strong><input type="text" value={pd.contract_term?.value || ''}
                    onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
                   start date{' '}
                  <strong><input type="text" value={pd.contract_period?.start_date || ''}
                    onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17" /></strong>
                  {' to '}
                  <strong><input type="text" value={pd.contract_period?.end_date || ''}
                    onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
                </span>
              </div>

              {/* Rate Per Hour - Editable */}
              <div className="flex items-center gap-2 ml-5">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Rate Per Hour –{' '}
                  <strong>
                    <input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-96" />
                  </strong>
                </span>
              </div>

              {/* Working Hours - Editable */}
              <div className="flex items-center gap-2 ml-5">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Working Hours –{' '}
                  <strong>
                    <input type="text" value={pd.working_hours?.value || ''}
                      onChange={e => patchProfile('working_hours', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-80" />
                  </strong>
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 ml-5">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>
          </div>

          {/* ── Violation Summary Table - Editable ── */}
          <div className="">
            <table className="!border-collapse text-[8px]">
              <thead>
                <tr>
                  <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[10px]">
                    {violationTable.title}
                  </th>
                </tr>
                <tr className="">
                  {[
                    { label: 'City Code',        w: '55px'  },
                    { label: 'Violation Code',   w: '60px'  },
                    { label: 'Violation_Name_En', w: '210px' },
                    { label: 'Ticket Charges',   w: '70px'  },
                    { label: 'Tow Charges',      w: '65px'  },
                    { label: 'Clamp Charges',    w: '65px'  },
                  ].map(({ label, w }) => (
                    <th key={label} className="!border !border-black px-2 py-1 font-bold text-center" style={{ minWidth: w }}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {violationTable.data.rows.map((row, rIdx) => (
                  <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
                    {[
                      { key: 'city_code',       w: '55px'  },
                      { key: 'violation_code',  w: '60px'  },
                      { key: 'violation_name',  isLong: true },
                      { key: 'ticket_charges',  w: '70px'  },
                      { key: 'tow_charges',     w: '65px'  },
                      { key: 'clamp_charges',   w: '65px'  },
                    ].map(({ key, w, isLong }) => (
                      <td key={key} className="!border !border-black px-1.5 py-0.5">
                        {isLong ? (
                          <textarea
                            value={row[key] || ''}
                            onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                            rows={1}
                            className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
                            style={{
                              minWidth: '260px',
                              minHeight: '22px',
                              lineHeight: '1.2',
                              padding: '3px 4px',
                            }}
                            onInput={e => {
                              e.target.style.height = 'auto';
                              e.target.style.height = e.target.scrollHeight + 'px';
                            }}
                          />
                        ) : (
                          <input
                            type="text"
                            value={row[key] || ''}
                            onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[8px] text-center"
                            style={{ width: w }}
                          />
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={assetsTable}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />
      </div>
    </div>
  );
};

export default JubailProfile;